import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { CreateBillingPortalSessionMutation } from '@/gql/graphql';

const CreateBillingPortalSession = graphql(`
  mutation CreateBillingPortalSession {
    createBillingPortalSession {
      ... on CreateBillingPortalSessionSuccess {
        __typename
        url
      }
      ... on CreateBillingPortalSessionError {
        __typename
        message
      }
    }
  }
`);

export const useCreateBillingPortalSession = (
  options?: UseMutationOptions<CreateBillingPortalSessionMutation, unknown>
) => {
  return useMutation({
    mutationFn: () => {
      return gqlClient.request(CreateBillingPortalSession);
    },
    ...options,
  });
};
